import type {
  GeneratedShotRowV2DictYMap,
  ShotListChoiceV2DictYMap,
  ShotListRowDict,
  ShotSeamDictYMap,
} from '../../../../generated/nodeDataTypes'

export const SHOT_LABELS: Readonly<Record<string, string>> = {
  wide_shot: 'WS (Wide Shot)', medium_shot: 'MS (Medium Shot)',
  close_up: 'CU (Close-Up)', over_the_shoulder: 'OTS', point_of_view: 'POV',
  extreme_close_up: 'ECU (Extreme Close-Up)',
}
export const ANGLE_LABELS: Readonly<Record<string, string>> = {
  eye_level: 'Eye-Level', low_angle: 'Low-Angle', high_angle: 'High-Angle',
  dutch_tilt: 'Dutch Tilt', over_the_shoulder: 'Over-the-Shoulder',
}
export const FOCUS_LABELS: Readonly<Record<string, string>> = {
  shallow_focus: 'Shallow Focus', medium_focus: 'Medium Focus', deep_focus: 'Deep Focus',
}

function label(choice: ShotListChoiceV2DictYMap | undefined, presets: Readonly<Record<string, string>>): string {
  if (!choice) return ''
  if (choice.custom) return choice.custom
  const id = choice.preset_id
  if (!id) return ''
  return presets[id] ?? id
}

/** Display-only projection; out_shots and out_shot_seams remain the canonical outputs. */
export function projectGeneratedShots(
  shots: readonly GeneratedShotRowV2DictYMap[],
  seams: readonly ShotSeamDictYMap[],
): ShotListRowDict[] {
  if (shots.length === 0 && seams.length === 0) return []
  if (seams.length !== shots.length + 1) {
    throw new Error(`Shot List has ${shots.length} shots but ${seams.length} seams`)
  }
  return shots.map((shot, index) => {
    const framing = shot.framing
    const lens = framing?.lens
    if (!shot.id || !shot.duration_ms || shot.visual_description === undefined ||
      shot.location === undefined || shot.interior_exterior === undefined ||
      seams[index].transition === undefined || seams[index + 1].transition === undefined) {
      throw new Error(`Generated shot ${index + 1} has a missing required field`)
    }
    const timeOfDay = ` – ${shot.time_of_day || 'TBC'}`
    return {
      id: shot.id,
      scene_ordinal: shot.scene_ordinal,
      duration_ms: shot.duration_ms,
      visual_description: shot.visual_description,
      location: `${[shot.interior_exterior, shot.location].filter(Boolean).join('. ') || 'TBC'}${timeOfDay}`,
      framing_shot: label(framing?.shot, SHOT_LABELS),
      framing_angle: label(framing?.angle, ANGLE_LABELS),
      framing_lens: lens ? `${lens.focal_length_mm} mm / f${lens.aperture_f_number}` : '',
      framing_focus: label(framing?.focus, FOCUS_LABELS),
      camera_movement: shot.camera_movement,
      transition_in: seams[index].transition,
      transition_out: seams[index + 1].transition,
      dialogue_voiceover: shot.dialogue_voiceover,
      sfx: shot.sfx,
    }
  })
}
